<!--<div class="flex items-center gap-7 font-sans w-full h-[5%] justify-end relative right-8 bottom-2 xl:bottom-0">
  <div 
  class="flex items-center gap-1.5">
    <span class="w-[10px] h-[10px] xl:w-[12px] xl:h-[12px] bg-dimot-2 rounded-sm"></span>
    <h2 class="text-[0.5rem] xl:text-[0.6rem] text-gray-500">Forecast</h2>
  </div>
  <div 
  class="flex items-center gap-1.5">
    <span class="w-[10px] h-[10px] xl:w-[12px] xl:h-[12px] rounded-sm bg-dimot-1"></span>
    <h2 class="text-[0.5rem] xl:text-[0.6rem] text-gray-500">Actual</h2>
  </div>
</div> -->

<div class="relative w-full h-[95%]">
  <!-- Container graph with overlay -->
  <div class="relative w-full h-full right-[13px] xl:right-0">
    <canvas [id]="chartId" class="dimot-chart-main"></canvas>
    
    <!-- Dropdown  -->
<div
  *ngIf="isOverlapChoiceOpen"
  class="absolute z-50 bg-white shadow-lg rounded-md border border-gray-200 py-1 3xl:py-1.5 flex flex-col min-w-[130px] 3xl:min-w-[145px] overlap-dropdown-menu"
  [style.left.px]="overlapChoicePosition.x"
  [style.top.px]="overlapChoicePosition.y"
  [style.transform]="overlapMenuAlign === 'right' ? 'translateX(-100%)' : 'none'"
>
      <div
        *ngFor="let candidate of overlappingCandidates"
        (click)="selectOverlappingPoint(candidate)"
        class="text-left text-[0.7rem] 3xl:text-[0.78rem] px-3 3xl:px-3.5 py-1.5 3xl:py-2 hover:bg-gray-100 flex items-center gap-2 whitespace-nowrap cursor-pointer"
      >
        <span
          class="w-[9px] h-[9px] 3xl:w-[10px] 3xl:h-[10px] rounded-xs"
          [style.background-color]="candidate.type === 'Actual' ? lineColor1 : lineColor2"
        ></span>
        {{ candidate.type }} — {{ candidate.value }}%
      </div>
      <div
        (click)="closeOverlapChoice()"
        class="text-left text-[0.65rem] 3xl:text-[0.72rem] px-3 3xl:px-3.5 py-1 3xl:py-1.5 text-gray-400 hover:bg-gray-100 border-t border-gray-100 cursor-pointer"
      >
        Annulla
      </div>
    </div>

    <!-- Messaggio "Nessun dato" - spostato DOPO il canvas e il dropdown -->
    <div *ngIf="!hasData" class="absolute inset-0 flex items-center justify-center pointer-events-none z-10">
      <p class="text-gray-400 font-medium text-[0.7rem] 2xl:text-[0.75rem] 3xl:text-[0.8rem] bg-sky-100 px-4 py-2 rounded-sm mb-5 ml-[23px] xl:ml-0">Non ci sono dati da mostrare</p>
    </div>
  </div>
</div>

<app-modal-open-to-access-curve
  *ngIf="isAccessCurveOpen"
  [curvePointData]="curvePointData"
  (isModalOpen)="onOpenAccessCurveModal($event)"
>
</app-modal-open-to-access-curve>